import request from '../utils/request';

// 分页查询陪逛服务提供者
export const listAccompanyShoppingProviders = (params) => {
  return request({
    url: '/accompany-shopping-provider/list',
    method: 'get',
    params
  });
};

// 查询单个陪逛服务提供者详情
export const getAccompanyShoppingProviderById = (id) => {
  return request({
    url: `/accompany-shopping-provider/${id}`,
    method: 'get'
  });
};

// 批量更新陪逛服务提供者状态
export const updateProvidersStatus = (providerIds, status) => {
  return request({
    url: '/accompany-shopping-provider/status',
    method: 'put',
    data: providerIds,
    params: { status }
  });
};

// 更新陪逛服务提供者认证状态
export const updateProviderCertificationStatus = (providerId, certificationStatus) => {
  return request({
    url: '/accompany-shopping-provider/certification',
    method: 'put',
    params: { 
      providerId, 
      certificationStatus 
    }
  });
};

// 更新陪逛服务提供者信息
export const updateAccompanyShoppingProvider = (providerData) => {
  return request({
    url: '/accompany-shopping-provider/update',
    method: 'put',
    data: providerData
  });
}; 